/** Plan chosen before account creation. Defaults to Trade so existing signup stays a 14-day Trade trial. */

export const SIGNUP_PLAN_KEY = 'pt_signup_plan';

export function normalizeSignupPlan(tier) {
  if (tier === 'track' || tier === 'essentials') return 'track';
  if (tier === 'trade' || tier === 'pro') return 'trade';
  return null;
}

export function setSignupPlan(tier) {
  const plan = normalizeSignupPlan(tier) || 'trade';
  try {
    sessionStorage.setItem(SIGNUP_PLAN_KEY, plan);
  } catch (_) {}
  return plan;
}

/** @returns {'track'|'trade'} */
export function readSignupPlan() {
  try {
    return normalizeSignupPlan(sessionStorage.getItem(SIGNUP_PLAN_KEY)) || 'trade';
  } catch (_) {
    return 'trade';
  }
}

export function clearSignupPlan() {
  try {
    sessionStorage.removeItem(SIGNUP_PLAN_KEY);
  } catch (_) {}
}
